// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16VUI","rootNoMargin":"styles_rootNoMargin__g06aJ"};